import { ImPhone } from "react-icons/im";

interface Props {
  callerNumber: string | null
}

export function VoiceCallBarRingingView(props: Props) {
  const { callerNumber } = props;

  return (
    <div className="flex items-center gap-2">
      <ImPhone className="text-amber-450 size-4 mr-2 animate-pulse" />
      <span className="text-sm text-white">{callerNumber || "Unknown"}</span>
      <span className="text-grey-500 text-sm">Calling...</span>
    </div>
  );
}
